import PropTypes from 'prop-types';
import React from 'react';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import Report from '../../../../common/components/Report';

const MultiplePredesReport = props => (
  <Report
    id={props.id}
    tabs={[
      {
        value: ReportDefinitions.MULTIPLE_PREDES_SUMMARY.id,
        label: 'Summary',
      },
      {
        value: ReportDefinitions.MULTIPLE_PREDES_DETAILS.id,
        label: 'Details',
        loadFromTable: true,
        loadFromTableMessage: 'app.warning.load.from.summary.report',
      },
    ]}
    {...props}
  />
);
export default MultiplePredesReport;

MultiplePredesReport.propTypes = {
  id: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.object),
  columns: PropTypes.arrayOf(PropTypes.object),
  generatedOnDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  reportId: PropTypes.string,
};
